export enum PageColumn {
    TAGS = 'tags',
    RECORDS = 'records',
    RECORDS_OF = 'records_of',
    ADVANCE_SEARCH = 'advance-records-search',
    PAST_SEARCH = 'past-search',
    RECORDSGRID = 'recordsGridEdit',
    CONTACTS = 'contacts',
    SHARED_CONTACT = 'shared_contact',
    CONTACTS_CATEGORIES = 'contactsCategories',
    ADD_RECORD = 'create-update-record',
    GLOBAL_USER = 'global-users-list',
    LEGACY_RECORDS = 'legacy-records',
    USER_SHARING_WITH_ME = 'user-sharing-with-me',
    RECORD_AS_SEEN_BY = 'record-as-seen-by',
    FAMILY_TREE = 'family-tree',
    FAMILY_MEMBERS = 'family-members'
}

export enum RecordType {
    PDF = 'PDF',
    IMAGE = 'IMAGE',
    WORD = 'WORD',
    EXCEL = 'EXCEL',
    POWERPOINT = 'POWERPOINT',
    AUDIO = 'AUDIO',
    VIDEO = 'VIDEO',
    INTERNAL_TEXT_DOCUMENT = 'INTERNAL TEXT',
    ZIP = 'ZIP'
}

export enum RecordData {
    legacy = 'legacy',
    accessibility = 'accessibility',
    createdDay = 'createdDay',
    id = 'id',
    title = 'title',
    recordType = 'recordType',
    relatedTagsName = 'linkedTagsRecords',
    globalSearch = 'global'
}
